import { Button, Col, Form, Modal, notification, Row, Select } from "antd";
import { useTranslation } from "react-i18next";
import { LandwirtMasterdata } from "types/masterdata.types";
import { useChangeTreuhandstellePreferencesMutation } from "store/datacontrol";

interface Props {
  initialValue: number;
  visible: boolean;
  data: LandwirtMasterdata[];
  useThsMailForEmployees: boolean;
  treuhandstelleId: number;
  refetchTreuhandstelleData(): void;
  onClose(): void;
}

function ContactTreuhaenderModal({
  initialValue,
  visible,
  onClose,
  data,
  useThsMailForEmployees,
  treuhandstelleId,
  refetchTreuhandstelleData,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [changeTreuhandstellePreferences] =
    useChangeTreuhandstellePreferencesMutation();

  const uniqueData = data.filter(
    (obj, index) =>
      data.findIndex((item) => item.treuhaenderId === obj.treuhaenderId) ===
      index
  );

  const options = uniqueData
    ? uniqueData.map((item: LandwirtMasterdata) => ({
        label: `${item.treuhaenderId} ${item.firstname} ${item.lastname}`,
        value: item.treuhaenderId,
      }))
    : [];

  const handleChangeThsPreferences = async (values: {
    useMailOnly: boolean;
    useThsMailForEmployees: boolean;
    contactTreuhaenderId?: number;
  }) => {
    try {
      const payload = await changeTreuhandstellePreferences({
        treuhandstelleId,
        ...values,
      }).unwrap();
      if (!payload.hasErrors) {
        refetchTreuhandstelleData();
        notification.success({
          message: t("data_control.change_ths_preferences_success"),
        });
      } else {
        notification.error({ message: payload.errorDetails.errorMessage });
      }
    } catch (error) {
      console.error("Error", error);
    } finally {
      onClose();
    }
  };

  const handleSubmit = (values: { option: number }) => {
    handleChangeThsPreferences({
      useMailOnly: true,
      useThsMailForEmployees,
      contactTreuhaenderId: values.option,
    });
  };

  return (
    <Modal
      footer={null}
      title={t("masterdata.lw_details.set_contact_treuhaender")}
      visible={visible}
      onCancel={onClose}
      destroyOnClose
    >
      <Form
        id="set-contact-treuhaender-form"
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={{ option: initialValue }}
      >
        <Form.Item name="option" rules={[{ required: true }]}>
          <Select
            options={options}
            placeholder={t(
              "masterdata.lw_details.set_contact_treuhaender_placeholder"
            )}
          />
        </Form.Item>
        <Row gutter={20}>
          <Col span={12}>
            <Button onClick={onClose} block>
              {t("abort")}
            </Button>
          </Col>
          <Col span={12}>
            <Button type="primary" htmlType="submit" block>
              {t("confirm")}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default ContactTreuhaenderModal;
